import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  HStack,
  Button,
  Text,
  VStack,
  InputGroup,
  InputRightAddon,
  Flex,
  Badge
} from '@chakra-ui/react';

// توابع کمکی برای جدا کردن و حذف کاما
const formatPrice = (val) => {
  if (!val) return '';
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const parsePrice = (val) => {
  if (!val) return '';
  return val.toString().replace(/,/g, '');
};

const SmartPriceInput = ({ 
  label = 'قیمت فروش', 
  value, 
  onChange, 
  purchasePrice = 0, 
  isRequired = false 
}) => {
  // تبدیل value به عدد برای محاسبات
  const numericValue = parseInt(parsePrice(value)) || 0;
  const numericPurchasePrice = parseInt(purchasePrice) || 0;

  // محاسبه سود و حاشیه سود
  const profit = numericValue - numericPurchasePrice;
  const profitMargin = numericPurchasePrice > 0 
    ? ((profit / numericPurchasePrice) * 100).toFixed(1) 
    : 0;
  
  const isProfitable = profit > 0;
  const isLoss = profit < 0;

  const handleChange = (e) => {
    // فقط اعداد را نگه می‌داریم
    const rawValue = parsePrice(e.target.value);
    if (!isNaN(rawValue)) {
      onChange(rawValue);
    }
  };

  const applyModifier = (type) => {
    let newValue = numericValue;
    
    switch (type) {
      case 'round1000':
        newValue = Math.round(numericValue / 1000) * 1000;
        break;
      case 'add10Percent':
        newValue = Math.round(numericValue * 1.1);
        break;
      case 'add20Percent':
        newValue = Math.round(numericValue * 1.2);
        break;
      case 'profit20FromPurchase':
        if (numericPurchasePrice > 0) {
          newValue = Math.round(numericPurchasePrice * 1.2);
        }
        break;
      default:
        break;
    }
    
    onChange(newValue.toString());
  };

  return (
    <FormControl isRequired={isRequired} mb={4}>
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        <FormLabel mb={0}>{label}</FormLabel>
        
        {/* نمایش زنده سود و زیان */}
        {numericPurchasePrice > 0 && numericValue > 0 && (
          <HStack spacing={2}>
            <Badge colorScheme={isProfitable ? 'green' : (isLoss ? 'red' : 'gray')}>
              سود: {formatPrice(Math.abs(profit))} تومان
            </Badge>
            <Badge colorScheme={isProfitable ? 'green' : (isLoss ? 'red' : 'gray')} variant="solid">
              {profitMargin}%
            </Badge>
          </HStack>
        )}
      </Flex>

      <InputGroup size="lg">
        <Input
          value={formatPrice(value)}
          onChange={handleChange}
          placeholder="مثلاً ۱۲۰,۰۰۰"
          dir="ltr"
          textAlign="right"
          fontSize="xl"
          fontWeight="bold"
        />
        <InputRightAddon children="تومان" />
      </InputGroup>

      {/* دکمه‌های سریع */}
      <HStack mt={3} spacing={2} overflowX="auto" pb={1}>
        <Button size="xs" colorScheme="blue" variant="outline" onClick={() => applyModifier('round1000')}>
          رند به ۱۰۰۰
        </Button>
        <Button size="xs" colorScheme="blue" variant="outline" onClick={() => applyModifier('add10Percent')}>
          +۱۰٪
        </Button>
        <Button size="xs" colorScheme="blue" variant="outline" onClick={() => applyModifier('add20Percent')}>
          +۲۰٪
        </Button>
        {numericPurchasePrice > 0 && (
          <Button size="xs" colorScheme="teal" variant="solid" onClick={() => applyModifier('profit20FromPurchase')}>
            قیمت با ۲۰٪ سود خرید
          </Button>
        )}
      </HStack>
    </FormControl>
  );
};

export default SmartPriceInput;
